<template>
  <!-- <header class="bg-gray-900 border-b border-gray-800 main-header"> -->
  <header class="main-header sticky top-0 z-50 pt-[env(safe-area-inset-top)]">
    <div
      class="pointer-events-none absolute inset-0 -z-10 border-b"
      :class="[
        isTransitionEnabled ? 'transition-colors duration-300' : '',
        hasScrolled ? 'bg-[#08070b] md:bg-[#08070b]/70 md:backdrop-blur-md border-white/15' : ['border-transparent', headerColor], 
        showMobileMenu && !isOrganizer ? 'max-md:bg-[#08070b] max-md:border-b-0' : ''
      ]"
    />
    <div class="max-w-[1800px] mx-auto my-0 min-h-16">
      <div class="w-full max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center gap-2 min-h-16 h-auto py-1">
        <!-- Logo -->
        <div class="flex items-center min-w-0 flex-1 md:flex-initial space-x-2 sm:space-x-4">
          <RouterLink
            to="/"
            class="logo md:text-lg whitespace-nowrap truncate max-w-[min(100%,11rem)] sm:max-w-none"
            @click="() => {scrollToTop(); if(showMobileMenu) showMobileMenu = false}"
          >
            <i class="fas fa-cube text-purple-400" /> M-GATE
          </RouterLink>
          <!-- Search -->
          <div v-if="!isOrganizer" class="hidden relative xl:block">
            <i class="absolute left-4 top-1/2 text-gray-300 transform -translate-y-1/2 fas fa-search" />
            <input v-model="searchQuery" type="text" :placeholder="$t('nav.search_events')"
              class="py-2 pr-3 pl-10 w-56 text-sm placeholder-gray-400 text-white rounded-full border bg-white/10 border-white/20 focus:outline-none focus:ring-2 focus:ring-purple-500"
              @keyup.enter="submitSearch"
            >
          </div>
          <!-- <button
            class="text-gray-300 icon-btn hover:text-white"
            :aria-label="$t('common.search')"
            @click="submitSearch"
          >
            <i class="fas fa-search" />
          </button> -->
        </div>

        <!-- Navigation (nhóm: Trang chủ, Sự kiện, Chợ thứ cấp, Cá nhân, Tạo sự kiện) -->
        <nav v-if="!isOrganizer" class="hidden gap-1 items-center md:flex">
          <!-- 1. Trang chủ -->
          <RouterLink to="/" class="px-2 lg:px-3 py-2 text-sm text-center font-medium rounded-md transition-colors nav-link"
            :class="isNavActive('home') ? 'nav-link--active' : 'text-gray-300 hover:text-white'" @click="scrollToTop">
            {{ $t('home') }}
          </RouterLink>

          <!-- 2. Membership (chỉ khi đã đăng nhập) -->
          <template v-if="authStore.isAuthenticated">
            <span class="text-gray-600 nav-sep" aria-hidden="true">|</span>
            <RouterLink to="/membership/card" class="px-2 lg:px-3 py-2 text-sm text-center font-medium rounded-md transition-colors nav-link"
              :class="isNavActive('membership') ? 'nav-link--active' : 'text-gray-300 hover:text-white'" @click="scrollToTop">
              {{ $t('nav.membership') }}
            </RouterLink>
          </template>

          <!-- 3. Sự kiện -->
          <span class="text-gray-600 nav-sep" aria-hidden="true">|</span>
          <RouterLink to="/events" class="px-2 lg:px-3 py-2 text-sm text-center font-medium rounded-md transition-colors nav-link"
            :class="isNavActive('events') ? 'nav-link--active' : 'text-gray-300 hover:text-white'" @click="scrollToTop">
            {{ $t('nav.events') }}
          </RouterLink>

          <!-- NFT Gateway Guide -->
          <span class="text-gray-600 nav-sep" aria-hidden="true">|</span>
          <RouterLink to="/gateway/guide" class="px-2 lg:px-3 py-2 text-sm text-center font-medium rounded-md transition-colors nav-link"
            :class="isNavActive('gatewayGuide') ? 'nav-link--active' : 'text-gray-300 hover:text-white'" @click="scrollToTop">
            NFT Gateway
          </RouterLink>

          <!-- 3. Chợ thứ cấp (dropdown) -->
          <template v-if="showMarketplaceNav">
            <span class="text-gray-600 nav-sep" aria-hidden="true">|</span>
            <div class="relative">
              <button ref="marketButtonRef" type="button"
                class="flex gap-1 items-center px-2 lg:px-3 py-2 text-sm font-medium rounded-md transition-colors nav-link"
                :class="(isNavActive('marketplace') || showMarketDropdown) ? 'nav-link--active' : 'text-gray-300 hover:text-white'"
                @click="showMarketDropdown = !showMarketDropdown">
                {{ $t('nav.marketplace') }}
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div v-if="showMarketDropdown"
                class="absolute left-0 z-50 py-1 mt-1 w-44 bg-[#09060f] rounded-md border border-white/15 shadow-lg shadow-black/70">
                <RouterLink to="/marketplace" class="block px-4 py-2 text-sm dropdown-link hover:bg-purple-500/20 hover:text-purple-300"
                  :class="isMarketplacePath('/marketplace') ? 'dropdown-link--active' : 'text-gray-400'"
                  @click="() => { scrollToTop(); showMarketDropdown = false }">
                  {{ $t('nav.market') }}
                </RouterLink>
                <RouterLink to="/marketplace/listings" class="block px-4 py-2 text-sm dropdown-link hover:bg-purple-500/20 hover:text-purple-300"
                  :class="isMarketplacePath('/marketplace/listings') ? 'dropdown-link--active' : 'text-gray-400'"
                  @click="() => { scrollToTop(); showMarketDropdown = false }">
                  {{ $t('nav.listings') }}
                </RouterLink>
                <RouterLink to="/marketplace/collections" class="block px-4 py-2 text-sm dropdown-link hover:bg-purple-500/20 hover:text-purple-300"
                  :class="isMarketplacePath('/marketplace/collections') ? 'dropdown-link--active' : 'text-gray-400'"
                  @click="() => { scrollToTop(); showMarketDropdown = false }">
                  {{ $t('nav.collections') }}
                </RouterLink>
                <RouterLink to="/marketplace/auctions" class="block px-4 py-2 text-sm dropdown-link hover:bg-purple-500/20 hover:text-purple-300"
                  :class="isMarketplacePath('/marketplace/auctions') ? 'dropdown-link--active' : 'text-gray-400'"
                  @click="() => { scrollToTop(); showMarketDropdown = false }">
                  {{ $t('nav.auctions') }}
                </RouterLink>
              </div>
            </div>
          </template>
          
          <!-- 4. Cá Nhân (chỉ khi đã đăng nhập) -->
          <template v-if="authStore.isAuthenticated">
            <span class="text-gray-600 nav-sep" aria-hidden="true">|</span>
            <RouterLink to="/account" class="px-2 lg:px-3 py-2 text-sm text-center font-medium rounded-md transition-colors nav-link"
              :class="isNavActive('account') ? 'nav-link--active' : 'text-gray-300 hover:text-white'"
              @click="scrollToTop"
            >
              {{ $t('nav.account') }}
            </RouterLink>
          </template>

          <!-- 5. Tổ chức - điều hướng vào list sự kiện của tổ chức -->
          <template v-if="authStore.canAccessOrganizerArea">
            <span class="text-gray-600 nav-sep" aria-hidden="true">|</span>
            <RouterLink to="/organizer/events" 
              class="px-2 lg:px-3 py-2 text-sm text-center font-medium rounded-md transition-colors nav-link"
              :class="isNavActive('organizer') ? 'nav-link--active' : 'text-gray-300 hover:text-white'"
              @click="scrollToTop">
              {{ hasFullOrganizerNav ? $t('nav.organizer_events') : $t('nav.my_events') }}
            </RouterLink>
          </template>

          <!-- 6. Quản trị - điều hướng vào admin -->
          <template v-if="authStore.isAdmin">
            <span class="text-gray-600 nav-sep" aria-hidden="true">|</span>
            <RouterLink to="/admin" 
              class="px-2 lg:px-3 py-2 text-sm text-center font-medium rounded-md transition-colors nav-link text-blue-400 hover:text-blue-300"
              @click="scrollToTop">
              {{ $t('nav.go_to_admin_page') }}
            </RouterLink>
          </template>
        </nav>

        <!-- Header Actions -->
        <div class="flex items-center justify-end shrink-0 gap-1">
          <LanguageSwitcher />
          <button
            v-if="showMarketplaceNav"
            type="button"
            class="inline-flex text-gray-300 icon-btn hover:text-white items-center justify-center"
            :aria-label="$t('common.dark_mode')"
          >
            <i class="fas fa-sun" />
          </button>
          <RouterLink
            v-if="showMarketplaceNav && !isOrganizer"
            to="/account/wallet"
            class="hidden md:inline-flex text-gray-300 icon-btn hover:text-white items-center justify-center"
            :aria-label="$t('common.my_wallet')"
            @click="() => { scrollToTop(); if (showMobileMenu) showMobileMenu = false }"
          >
            <i class="fas fa-wallet" />
          </RouterLink>
          <MerchantContextSelector />
          <UserNotificationsDropdown v-if="showMarketplaceNav" /> <!-- [SOCKET_CONTROL]: Hidden for release -->

          <template v-if="authStore.isAuthenticated">
            <!-- User Dropdown -->
            <div class="relative">
              <button
                ref="userButtonRef"
                type="button"
                class="flex items-center px-2 py-2 min-h-[44px] space-x-2 text-sm font-medium text-gray-300 rounded-md transition-colors hover:text-white"
                :aria-expanded="showUserMenu"
                @click="showUserMenu = !showUserMenu"
              >
                <img 
                  v-if="authStore.user?.avatar || authStore.user?.profilePicture" 
                  :src="authStore.user.avatar || authStore.user.profilePicture" 
                  :alt="authStore.user?.firstName || 'User'"
                  class="w-10 h-10 rounded-full bg-[#030303] text-white"
                >
                <div v-else-if="authStore.user?.firstName || authStore.user?.email" class="flex justify-center items-center w-10 h-10 bg-purple-700 rounded-full">
                  <span class="text-base font-medium uppercase text-white">
                    {{ authStore.user?.firstName?.charAt(0) || authStore.user?.email?.charAt(0) }}
                  </span>
                </div>
                <div v-else class="flex justify-center items-center w-10 h-10 bg-purple-600 rounded-full">
                  <i class="fas fa-user text-white" aria-hidden="true" />
                </div>            
                <div v-if="!isOrganizer" class="hidden md:block lg:hidden absolute right-[5px] bottom-[5px] w-4 h-4 bg-zinc-900 border border-zinc-800 rounded-full flex items-center justify-center">
                  <i class="fas fa-angle-down text-[10px]" />
                </div>
                <span :class="['max-w-28 truncate', isOrganizer ? '' : 'md:hidden lg:block']">
                  {{ authStore.user?.firstName || authStore.user?.email }}
                </span>
                <svg :class="['w-4 h-4', isOrganizer ? '' : 'md:hidden lg:block']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>

              <!-- Dropdown Menu -->
              <div v-if="showUserMenu" class="absolute right-0 z-50 py-1 pt-0 w-52 bg-[#09060f] border border-white/15 rounded-md shadow-lg shadow-black/70">
                <div class="p-3 flex items-center space-x-2">
                  <img 
                    v-if="authStore.user?.avatar || authStore.user?.profilePicture" 
                    :src="authStore.user.avatar || authStore.user.profilePicture" 
                    :alt="authStore.user?.firstName || 'User'" 
                    class="w-10 h-10 rounded-full bg-[#030303]"
                  >
                  <div v-else-if="authStore.user?.firstName || authStore.user?.email" class="flex justify-center items-center w-10 h-10 bg-purple-700 rounded-full">
                    <span class="text-base font-medium uppercase text-white">
                      {{ authStore.user?.firstName?.charAt(0) || authStore.user?.email?.charAt(0) }}
                    </span>
                  </div>
                  <div v-else class="flex justify-center items-center w-8 h-8 bg-purple-600 rounded-full">
                    <i class="fas fa-user text-sm text-white" aria-hidden="true" />
                  </div>
                  <span class='text-sm text-white font-semibold max-w-28 truncate'>
                    {{ authStore.user?.firstName || authStore.user?.email }}
                  </span>
                </div>
                <div class="h-[1px] bg-gradient-to-r from-transparent via-white/25 to-transparent" />
                <RouterLink to="/account"
                  class="block px-4 py-2 text-sm text-gray-400 hover:bg-purple-500/20 hover:text-purple-300"
                  @click="() => {scrollToTop(); showUserMenu = false; if(showMobileMenu) showMobileMenu = false}">
                  <i class="fa-solid fa-user mr-2" /> {{ $t('nav.my_account') }}
                </RouterLink>
                <template v-if="authStore.canAccessOrganizerArea">
                  <RouterLink to="/organizer/events"
                    class="block px-4 py-2 text-sm text-gray-400 hover:bg-purple-500/20 hover:text-purple-300"
                    @click="() => {scrollToTop(); showUserMenu = false; if(showMobileMenu) showMobileMenu = false}">
                    <i class="fas fa-calendar-days mr-2.5" /> {{ $t('nav.event_management') }}
                  </RouterLink>
                  <RouterLink to="/organizer/account-settings"
                    class="block px-4 py-2 text-sm text-gray-400 hover:bg-purple-500/20 hover:text-purple-300"
                    @click="() => {scrollToTop(); showUserMenu = false; if(showMobileMenu) showMobileMenu = false}">
                    <i class="fas fa-user-cog mr-1.5" /> {{ $t('nav.account_settings') }}
                  </RouterLink>
                </template>
                <RouterLink v-if="authStore.isAdmin" to="/admin"
                  class="block px-4 py-2 text-sm text-gray-400 hover:bg-purple-500/20 hover:text-purple-300"
                  @click="() => {scrollToTop(); showUserMenu = false; if(showMobileMenu) showMobileMenu = false}">
                  <i class="fa-solid fa-chart-line mr-2" /> {{ $t('nav.go_to_admin_page') }}
                </RouterLink>
                <RouterLink v-if="!isOrganizer" to="/account/tickets"
                  class="block px-4 py-2 text-sm text-gray-400 hover:bg-purple-500/20 hover:text-purple-300"
                  @click="() => {scrollToTop(); showUserMenu = false; if(showMobileMenu) showMobileMenu = false}">
                  <i class="fa-solid fa-ticket-simple mr-[5px]" /> {{ $t('nav.my_tickets') }}
                </RouterLink>
                <RouterLink v-if="showMarketplaceNav && !isOrganizer" to="/account/wallet"
                  class="block px-4 py-2 text-sm text-gray-400 hover:bg-purple-500/20 hover:text-purple-300"
                  @click="() => {scrollToTop(); showUserMenu = false; if(showMobileMenu) showMobileMenu = false}">
                  <i class="fa-solid fa-wallet mr-2" /> {{ $t('nav.multi_chain_wallet') }}
                </RouterLink>
                <div class="h-[0.5px] bg-gradient-to-r from-transparent via-white/25 to-transparent" />
                <button class="block px-4 py-2 w-full text-sm text-left text-red-400 hover:bg-red-500/20 hover:text-red-300"
                  @click="handleLogout">
                  <i class="fa-solid fa-right-from-bracket mr-2" /> {{ $t('nav.logout') }}
                </button>
              </div>
            </div>
          </template>

          <template v-else>
            <RouterLink
              to="/auth"
              class="btn btn-primary btn-padding mx-2 text-[13px] sm:text-sm whitespace-nowrap shrink-0"
            >
              {{ $t('nav.login') }}
            </RouterLink>
          </template>
        </div>

        <!-- Mobile Menu Toggle -->
        <button
          v-if="!isOrganizer"
          type="button"
          class="text-gray-300 mobile-menu-toggle md:hidden hover:text-white inline-flex items-center justify-center min-h-[44px] min-w-[44px] -mr-1 sm:mr-0 shrink-0"
          :class="showMobileMenu ? 'bg-purple-600 hover:bg-purple-600' : ''"
          :aria-expanded="showMobileMenu"
          :aria-label="$t('common.open_menu')"
          @click="showMobileMenu = !showMobileMenu"
        >
          <i class="fas fa-bars" />
        </button>
      </div>

      <!-- Mobile Navigation (cùng nhóm: Trang chủ, Sự kiện, Chợ thứ cấp, Cá nhân, Tạo sự kiện) -->
      <div
        v-if="showMobileMenu && !isOrganizer"
        class="px-2.5 sm:px-4 pb-4 pb-[max(1rem,env(safe-area-inset-bottom))] border-b border-white/15 md:hidden"
      >
        <nav class="mobile-nav">
          <div class="px-4 py-4 space-y-1 max-h-[min(70vh,100dvh-5rem)] overflow-y-auto overscroll-contain scrollbar-glass">
            <div class="py-2 text-xs tracking-wider text-gray-500 uppercase">
              {{ $t('home') }}
            </div>
            <RouterLink
              to="/" class="block px-3 py-2 rounded-md mobile-nav-link"
              :class="isNavActive('home') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
              @click="() => { scrollToTop(); showMobileMenu = false }"
            >
              {{ $t('home') }}
            </RouterLink>

            <div class="py-2 pt-3 text-xs tracking-wider text-gray-500 uppercase">
              {{ $t('nav.events') }}
            </div>
            <RouterLink
              to="/events" class="block px-3 py-2 rounded-md mobile-nav-link"
              :class="isNavActive('events') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
              @click="() => { scrollToTop(); showMobileMenu = false }"
            >
              {{ $t('nav.events') }}
            </RouterLink>

            <div class="py-2 pt-3 text-xs tracking-wider text-gray-500 uppercase">
              NFT Gateway
            </div>
            <RouterLink
              to="/gateway/guide" class="block px-3 py-2 rounded-md mobile-nav-link"
              :class="isNavActive('gatewayGuide') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
              @click="() => { scrollToTop(); showMobileMenu = false }"
            >
              NFT Gateway Guide
            </RouterLink>

            <template v-if="showMarketplaceNav">
              <div class="py-2 pt-3 text-xs tracking-wider text-gray-500 uppercase">
                {{ $t('nav.marketplace') }}
              </div>
              <RouterLink
                to="/marketplace" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="isMarketplacePath('/marketplace') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.market') }}
              </RouterLink>
              <RouterLink
                to="/marketplace/listings" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="isMarketplacePath('/marketplace/listings') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.listings') }}
              </RouterLink>
              <RouterLink
                to="/marketplace/collections" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="isMarketplacePath('/marketplace/collections') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.collections') }}
              </RouterLink>
              <RouterLink
                to="/marketplace/auctions" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="isMarketplacePath('/marketplace/auctions') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.auctions') }}
              </RouterLink>
            </template>

            <template v-if="authStore.isAuthenticated">
              <div class="py-2 pt-3 text-xs tracking-wider text-gray-500 uppercase">
                {{ $t('nav.membership') }}
              </div>
              <RouterLink
                to="/membership/card" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="route.path.startsWith('/membership') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.membership_card') }}
              </RouterLink>
              <div class="py-2 pt-3 text-xs tracking-wider text-gray-500 uppercase">
                {{ $t('nav.account') }}
              </div>
              <RouterLink
                to="/account" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="isNavActive('account') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.my_account') }}
              </RouterLink>
              <RouterLink
                to="/account/tickets" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="route.path === '/account/tickets' ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.my_tickets') }}
              </RouterLink>
              <RouterLink
                v-if="showMarketplaceNav"
                to="/account/wallet" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="route.path === '/account/wallet' ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('common.my_wallet') }}
              </RouterLink>
            </template>

            <template v-if="authStore.isAuthenticated && authStore.canAccessOrganizerArea">
              <div class="py-2 pt-3 text-xs tracking-wider text-gray-500 uppercase">
                {{ $t('nav.event_management') }}
              </div>
              <RouterLink
                to="/organizer/events" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="isNavActive('organizer') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ hasFullOrganizerNav ? $t('nav.organizer_events') : $t('nav.my_events') }}
              </RouterLink>
              <RouterLink
                to="/events/create" class="block px-3 py-2 rounded-md mobile-nav-link"
                :class="isNavActive('createEvent') ? 'mobile-nav-link--active' : 'mobile-nav-link--hover'"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.create_event') }}
              </RouterLink>              
            </template>

            <template v-if="authStore.isAuthenticated && authStore.isAdmin">
              <div class="py-2 pt-3 text-xs tracking-wider text-gray-500 uppercase">
                {{ $t('admin.nav.brand_title') }}
              </div>
              <RouterLink
                to="/admin" class="block px-3 py-2 rounded-md mobile-nav-link text-blue-400"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                <i class="fa-solid fa-chart-line mr-2" /> {{ $t('nav.go_to_admin_page') }}
              </RouterLink>
            </template>

            <div v-if="!authStore.isAuthenticated" class="pt-4">
              <RouterLink
                to="/auth"
                class="block w-full text-center btn btn-primary"
                @click="() => { scrollToTop(); showMobileMenu = false }"
              >
                {{ $t('nav.login') }}
              </RouterLink>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useMerchantStore } from '@/stores/merchant'
import { useToast } from 'vue-toastification'
import { scrollToTop } from '@/utils/commonUtils'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import MerchantContextSelector from '@/components/layout/MerchantContextSelector.vue'
import UserNotificationsDropdown from '@/components/notifications/UserNotificationsDropdown.vue'
import { useReleaseFeatureFlags } from '@/composables/useReleaseFeatureFlags'

const router = useRouter()
const route = useRoute()
const { t } = useI18n()
const authStore = useAuthStore()
const merchantStore = useMerchantStore()
const toast = useToast()

const showUserMenu = ref(false)
const showMobileMenu = ref(false)
const showMarketDropdown = ref(false)
const searchQuery = ref('')

const { showMarketplaceNav } = useReleaseFeatureFlags()
/** Show "Create Event" only for organizer/admin */
// const canCreateEvent = computed(() => authStore.isAuthenticated)
const isOrganizer = computed(() => authStore.isAuthenticated && (authStore.isOrganizer || authStore.isAdmin))
const hasFullOrganizerNav = computed(() => authStore.isAuthenticated && authStore.hasFullOrganizerNav)
const userButtonRef = ref<HTMLElement | null>(null)
const marketButtonRef = ref<HTMLElement | null>(null)

const hasScrolled = ref(false)
let ticking = false

const handleScroll = () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      // Ngưỡng 8px để đổi trạng thái
      hasScrolled.value = window.scrollY > 8
      ticking = false
    })
    ticking = true
  }
}

/** Kiểm tra nav item có đang active theo path hiện tại */
function isNavActive(section: 'home' | 'events' | 'marketplace' | 'account' | 'organizer' | 'createEvent' | 'gatewayGuide' | 'membership'): boolean {
  const path = route.path
  switch (section) {
    case 'home':
      return path === '/'
    case 'events':
      return path.startsWith('/events') && !path.includes('/events/create')
    case 'gatewayGuide':
      return path.startsWith('/gateway/guide')
    case 'membership':
      return path.startsWith('/membership')
    case 'marketplace':
      return path.startsWith('/marketplace')
    case 'account':
      return path.startsWith('/account')
    case 'organizer':
      return path.startsWith('/organizer')
    case 'createEvent':
      return path.startsWith('/events/create')
    default:
      return false
  }
}

/** Active cho item trong dropdown Chợ thứ cấp (exact hoặc prefix) */
function isMarketplacePath(toPath: string): boolean {
  const path = route.path
  if (toPath === '/marketplace') return path === '/marketplace'
  return path === toPath || path.startsWith(toPath + '/')
}

const formatAddress = (address: string) => {
  if (!address) return ''
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}

const copyWalletAddress = async () => {
  if (authStore.user?.walletAddress) {
    try {
      await navigator.clipboard.writeText(authStore.user.walletAddress)
      toast.success(t('common.copy_address'))
    } catch (error) {
      toast.error(t('common.copy_failed'))
    }
  }
}

const handleLogout = () => {
  authStore.logout()
  merchantStore.staffLogout()
  showUserMenu.value = false
  router.push('/')
  toast.success(t('common.logout_success'))
  scrollToTop();
}

const submitSearch = () => {
  scrollToTop();
  const q = searchQuery.value.trim()
  if (!q) {
    router.push('/events')
    return
  }
  router.push({ path: '/events', query: { q } })
}

// Close dropdowns when clicking outside
const handleClickOutside = (event: Event) => {
  // const target = event.target as HTMLElement
  // if (!target.closest('.relative')) {
  //   showUserMenu.value = false
  //   showMarketDropdown.value = false
  // }
  const target = event.target as Node
  if (userButtonRef.value && !userButtonRef.value.contains(target)) showUserMenu.value = false
  if (marketButtonRef.value && !marketButtonRef.value.contains(target)) showMarketDropdown.value = false
}

interface Props {
  headerColor?: string
}
const props = withDefaults(defineProps<Props>(), {
  headerColor: ''
})

// State để kiểm soát việc có cho phép transition hay không
const isTransitionEnabled = ref(true)

// Theo dõi khi giá trị màu từ prop thay đổi
watch(() => props.headerColor, async () => {
  isTransitionEnabled.value = false;

  // Chờ cho đến khi trình duyệt chuẩn bị vẽ khung hình tiếp theo
  requestAnimationFrame(() => {
    // Sau khi vẽ xong, khung hình tiếp theo bật lại transition
    requestAnimationFrame(() => {
      isTransitionEnabled.value = true;
    })
  })
})

// Add event listener for clicking outside
onMounted(() => {
  // passive: true cực kỳ quan trọng cho hiệu năng cuộn
  window.addEventListener('scroll', handleScroll, { passive: true })
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
/* Active tab: nổi bật so với mục thường */
.nav-link--active {
  @apply text-white font-semibold bg-white/10 border border-white/20;
}

.nav-link--active:hover {
  @apply text-white;
}

/* Logo hover effect */
/* .logo {
  @apply text-2xl font-bold text-white transition-colors;
}
.logo:hover{
  @apply text-transparent bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text;
} */

/* Dropdown item đang active */
.dropdown-link--active {
  @apply text-purple-200 bg-purple-400/30 font-medium;
}

/* Mobile: mục active */
.mobile-nav-link--active {
  @apply text-white font-medium bg-purple-600;
}

.mobile-nav-link--hover {
  @apply text-gray-300 hover:text-white;
}

.mobile-nav {
  @apply w-full max-w-[1800px] mx-auto px-2 sm:px-4 bg-white/[0.08] border-t border-white/20 rounded-xl;
}
</style>
